const apiUrl = process.env.REACT_APP_API_URL;

const getJourneyAnalysis = (token, id, params, cb) => {
    fetch(`${apiUrl}/journeyanalysis/${id}?${params}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getJourneyAnalysis;
